// Opaque type removed - see /packages/utilities/type-safety/README.md for more information

export type ResultType<e, a> =
  | {
      tag: 'Error';
      val: e;
    }
  | {
      tag: 'Ok';
      val: a;
    };

export const Error = <e, a>(val: e): ResultType<e, a> => ({tag: 'Error', val});

export const Ok = <e, a>(val: a): ResultType<e, a> => ({tag: 'Ok', val});

export const match =
  <e, a, b>(matcher: {
    Error: (arg1: e) => b;
    Ok: (arg1: a) => b;
  }): ((arg1: ResultType<e, a>) => b) =>
  (result: ResultType<e, a>) =>
    result.tag === 'Ok' ? matcher.Ok(result.val) : matcher.Error(result.val);

// Compared to `match`, `when` has better TypeScript inference for matcher when
// the type of result is known.
export const when = <e, a, b>(
  result: ResultType<e, a>,
  matcher: {
    Error: (arg1: e) => b;
    Ok: (arg1: a) => b;
  }
) => (result.tag === 'Ok' ? matcher.Ok(result.val) : matcher.Error(result.val));

export const map = <e, a, b>(
  res: ResultType<e, a>,
  fn: (x: a) => b
): ResultType<e, b> => {
  if (res.tag === 'Error') return res;
  return Ok(fn(res.val));
};
